import React, { useState } from "react";
import { VirtualSpace } from "@lifeat/shared/data-models/virtual-space/VirtualSpace";
import LifeAtButton from "@common/LifeAtButton/LifeAtButton";
import { AppearanceContextType, useAppearanceContext } from "@contexts/AppearanceContext";
import { CallToActionContextType, useCallToActionContext } from "@contexts/CallToActionContext";
import { UserContextType, useUserContext } from "@contexts/UserContext";
import SavedSpaceIcon from "@icons/SpaceSavedIcon.svg";
import { SignUpCTASource } from "@user/AmplitudeUserEvents";
import "./SpaceActions/SpaceActions.scss";

const SPACE_IS_SAVING_ANIMATION_TIME = 2000;

const SAVING_SPACE_AUDIO: any = document.getElementById("savingSpaceAudio");
const SAVING_SPACE_AUDIO_VOL = 0.4;
if (SAVING_SPACE_AUDIO) {
    SAVING_SPACE_AUDIO.volume = SAVING_SPACE_AUDIO_VOL;
}

const UNSAVING_SPACE_AUDIO: any = document.getElementById("unsavingSpaceAudio");
const UNSAVING_SPACE_AUDIO_VOL = 0.3;
if (UNSAVING_SPACE_AUDIO) {
    UNSAVING_SPACE_AUDIO.volume = UNSAVING_SPACE_AUDIO_VOL;
}

interface SaveSpaceButtonProps {
    // These props relate to the current space the user is on.
    readonly currSpace: VirtualSpace;
    readonly isCurrSpaceSaved: boolean;
    readonly toggleSpaceIsSaved: (saveSpace: boolean, space: VirtualSpace) => void;
}
export default function SaveSpaceButton(props: SaveSpaceButtonProps) {
    const { lightMode }: AppearanceContextType = useAppearanceContext();
    const { user, userData }: UserContextType = useUserContext();
    const { setSignInView }: CallToActionContextType = useCallToActionContext();

    // Used for animation
    const [isSpaceSaving, setIsSpaceSaving] = useState(false);

    const handleSavingSpace = () => {
        if (user && userData) {
            if (props.isCurrSpaceSaved) {
                UNSAVING_SPACE_AUDIO.play();
            } else {
                SAVING_SPACE_AUDIO.play();
            }

            props.toggleSpaceIsSaved(!props.isCurrSpaceSaved, props.currSpace);
            setIsSpaceSaving(true);
            setTimeout(() => {
                setIsSpaceSaving(false);
            }, SPACE_IS_SAVING_ANIMATION_TIME);
        } else {
            setSignInView(SignUpCTASource.SAVE_SPACE);
        }
    };

    const saveSpaceButton = (
        <LifeAtButton
            isLink={false}
            icon={<SavedSpaceIcon className={`saved-space-icon ${props.isCurrSpaceSaved ? "filled" : "unfilled"}`} />}
            handleClick={handleSavingSpace}
            className={`save-space-button`}
        />
    );

    const getSpaceActionButtonClassNames = () => {
        const lightModeClass = lightMode ? " light" : " dark";
        const saving = isSpaceSaving ? " saving" : "";
        return lightModeClass + saving;
    };

    return <span className={getSpaceActionButtonClassNames()}>{saveSpaceButton}</span>;
}
